import React, { Component } from 'react';
import SimplePopover from '../../SimplePopover';
import GraficoBarra from '../../charts/GraficoBarra';
import PopupNotas from './PopupNotas';

class Habilidades extends Component {

    getMediasHabilidade() {
        return this.props.mediasHabilidade || [];
    }

    render() {
        return (<div>

            {/* Lista habilidades (Mobile) */}
            <table className="edb-table edb-striped edb-hide-large edb-margin-large-bottom">
                <tbody>
                {this.getMediasHabilidade().map((habilidade, index) => {
                    return <tr key={'habilidades_m_'+index}>
                        <td>
                            <div className="edb-row-cell">
                                <div className="edb-cell edb-small">
                                    {!this.props.grade && habilidade.pcCorrectStudent < habilidade.pcCorrectSchool && <SimplePopover content="Sua média é menor do que a média da sua escola">
                                        <i className="fas fa-exclamation-triangle adap-text-red  edb-padding-small-top edb-padding-small-right "></i>
                                    </SimplePopover>}
                                    <strong>{habilidade.txShortName}:</strong>{habilidade.txExpertise}
                            </div>
                                <div className="edb-cell">
                                    <SimplePopover noPadding={true} rightAlign={true} content={
                                        <div>
                                            {false && <a href="/" className="edb-bar-item edb-button  edb-small">
                                                <i className="fas fa-check-square edb-padding-small-top adap-text-darkergray edb-margin-small-right"></i>
                                                Ver questões
                                            </a>}
                                            {false && <a href="/" className="edb-bar-item edb-button  edb-small">
                                                <i className="fas fa-clock edb-padding-small-top adap-text-darkergray edb-margin-small-right"></i>
                                                Alocar estudo
                                            </a>}
                                        </div>
                                    }>
                                    </SimplePopover>
                                </div>
                            </div>

                            {!this.props.grade && <SimplePopover block={true} topAlign={true} content={<PopupNotas titulo={habilidade.txShortName+" "+habilidade.txExpertise.split("-")[0]} meuDesempenho={habilidade.pcCorrectStudent} minhaEscola={habilidade.pcCorrectSchool} escolaReferencia={0} />}>
                                <GraficoBarra className="" percentage={habilidade.pcCorrectStudent} indicatorPercentage={habilidade.pcCorrectSchool} starPercentage={0} />
                            </SimplePopover>}
                            {this.props.grade && <SimplePopover block={true} topAlign={true} content={<PopupNotas titulo={habilidade.txShortName+" "+habilidade.txExpertise.split("-")[0]} grade={this.props.grade} meuDesempenho={habilidade.pcCorrectSchool} minhaEscola={0} escolaReferencia={0} />}>
                                <GraficoBarra className="" percentage={habilidade.pcCorrectSchool} indicatorPercentage={0} starPercentage={0} />
                            </SimplePopover>}
                        </td>
                    </tr>
                    })}
                </tbody>
            </table>

            {/* ========================================================================================================
                Lista habilidades (Desktop)
            ========================================================================================================  */}
            <table className="edb-table edb-striped edb-hide-small edb-hide-medium edb-margin-large-bottom">
                <tbody>
                    {this.getMediasHabilidade().map((habilidade,index) => {
                    return <tr key={'habilidades_m_'+index}>
                        <td width="30%">
                            {!this.props.grade && <SimplePopover block={true} topAlign={true} content={<PopupNotas titulo={habilidade.txShortName+" "+habilidade.txExpertise.split("-")[0] } meuDesempenho={habilidade.pcCorrectStudent} minhaEscola={habilidade.pcCorrectSchool} escolaReferencia={0} />}>
                                <GraficoBarra className="" percentage={habilidade.pcCorrectStudent} indicatorPercentage={habilidade.pcCorrectSchool} starPercentage={0} />
                            </SimplePopover>}
                            {this.props.grade && <SimplePopover block={true} topAlign={true} content={<PopupNotas titulo={habilidade.txShortName+" "+habilidade.txExpertise.split("-")[0] } grade={this.props.grade} meuDesempenho={habilidade.pcCorrectSchool} minhaEscola={0} escolaReferencia={0} />}>
                                <GraficoBarra className="" percentage={habilidade.pcCorrectSchool} indicatorPercentage={0} starPercentage={0} />
                            </SimplePopover>}
                        </td>
                        <td width="110">
                            {false && <SimplePopover content="Ver questões que você respondeu sobre esse tema">
                                <i className="fas fa-check-square edb-padding-small-top adap-text-darkergray"></i>
                            </SimplePopover>}

                            {false && <SimplePopover content="Alocar estudo sobre esse tema">
                                <i className="fas fa-clock edb-padding-small-top edb-padding-left adap-text-darkergray"></i>
                            </SimplePopover>}

                            {!this.props.grade && habilidade.pcCorrectStudent < habilidade.pcCorrectSchool && <SimplePopover content="Sua média é menor do que a média da sua escola">
                                <i className="fas fa-exclamation-triangle adap-text-red  edb-padding-small-top edb-padding-left "></i>
                            </SimplePopover>}
                        </td>
                        <td>
                            <strong>{habilidade.txShortName}:</strong>{habilidade.txExpertise}
                        </td>
                    </tr>
                    })}

                </tbody>
            </table>
        </div>);
    }
}

export default Habilidades;